import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Text from "../../../main/Text";
import BackButton from '../../../main/BackButton';
import axios from '../../../../axios-backend';

const ProductInfo = (props) => {
    const location = useLocation();
    const title = location.state?.title;
    const tid = location.state?.tid;
    const [content, setContent] = useState('');
    useEffect(() => {
        if (title && tid) {
            axios.get('/get-product-details-info', {
                params: { title, tid }
            }).then(data => {
                if (data.data.status === 200 && data.data.content) {
                    setContent(data.data.content)
                }
            });
        }
    }, [title, tid]);
    return (
        <>
            <BackButton />
            <Text>
                {content.split('\n').map(val => {
                    return (
                        <>{val}  <br /></>
                    )
                })}
            </Text>
        </>
    );
}


export default ProductInfo;

